import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "@/firebase";

const region =
  import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION || "us-central1";

const functions = getFunctions(app, region);

export async function requestCashbackWithdrawal(params: {
  amount: number;
  method: "bank_transfer" | "wallet";
  details: string;
}): Promise<{ data: unknown }> {
  const fn = httpsCallable(functions, "requestCashbackWithdrawal");
  return fn(params);
}

export async function transferCashbackToReferral(params: {
  toReferralCode: string;
  amount: number;
}): Promise<{ data: unknown }> {
  const fn = httpsCallable(functions, "transferCashbackToReferral");
  return fn(params);
}
